import TextArea from "antd/es/input/TextArea";
import { t } from "i18next";
import { useContext, useMemo, useState } from "react";
import { Modal } from "../../../../../components/Modal/Modal";
import { ModalsContext } from "../../../../../context/modals.context";
import {
  useAcceptProductionCodeRequest,
  useDeclineProductionCodeRequest,
} from "../../../../../modules/productionCode/productionCode.queries";
import { toastService } from "../../../../../utils/toast.service";

const ProductionCodeApprovalModal = () => {
  const {
    isModalVisible,
    modals: { type, zahtevId },
    clearModals,
    setError,
  } = useContext(ModalsContext);
  const [note, setNote] = useState("");

  const {
    mutate: acceptProductionCodeRequest,
    isPending: isAcceptingProductionCodeRequest,
  } = useAcceptProductionCodeRequest({
    onError: onErrorHandler,
    onSuccess: onSuccessHandler,
  });

  const {
    mutate: declineProductionCodeRequest,
    isPending: isDecliningProductionCodeRequest,
  } = useDeclineProductionCodeRequest({
    onError: onErrorHandler,
    onSuccess: onSuccessHandler,
  });

  function onSuccessHandler() {
    switch (type) {
      case "decline":
        toastService.success("TOAST.USPESNO_STE_ODBILI_ZAHTEV");
        break;
      case "accept":
        toastService.success("TOAST.USPESNO_STE_ODOBRILI_ZAHTEV");
        break;
      default:
        toastService.success("TOAST.USPEH");
        break;
    }

    setNote("");
    clearModals();
  }

  function onErrorHandler(error: Error | string) {
    setError(
      typeof error === "string" ? error : t("COMMON.DOSLO_JE_DO_GRESKE")
    );
  }

  const title = useMemo(() => {
    switch (type) {
      case "decline":
        return t("COMMON.ODBIJANJE_ZAHTEVA");
      case "accept":
      default:
        return t("COMMON.ODOBRENJE_ZAHTEVA");
    }
  }, [type]);

  const okButtonText = useMemo(() => {
    switch (type) {
      case "decline":
        return t("QR_CODE.ODBIJ_ZAHTEV");
      case "accept":
        return t("QR_CODE.ODOBRI_ZAHTEV");
      default:
        return t("AKCIZNE_MARKICE.POSALJI_ZAHTEV");
    }
  }, [type]);

  const handleOk = () => {
    if (type === "decline") {
      declineProductionCodeRequest({ note, zahtevId });
    } else if (type === "accept") {
      acceptProductionCodeRequest({ note, zahtevId });
    }
    setNote("");
  };

  const handleCancel = () => {
    clearModals();
    setNote("");
  };

  const handleNoteChange = (event: any) => {
    setNote(event?.target.value);
  };

  return (
    <Modal
      title={title}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText={t("COMMON.NAZAD")}
      name="productionCodeApprovalModal"
      cancelButtonProps={{ type: "default" }}
      okText={okButtonText}
      open={isModalVisible("productionCodeApprovalModal")}
      confirmLoading={
        isAcceptingProductionCodeRequest || isDecliningProductionCodeRequest
      }
    >
      <TextArea value={note} onChange={handleNoteChange} />
    </Modal>
  );
};

export default ProductionCodeApprovalModal;
